import VendorCreateContainer from "@legacy/vendors/VendorCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { VENDOR_ROUTES } from "@routes/vendor"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function VendorEdit() {
    const vendorId = window.VENDOR_ID

    const [detailsRoute] = useSlugExtractor([VENDOR_ROUTES.DETAILS], vendorId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("vendors_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle label="Edit Vendor" backDestination={detailsBackDestination} />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <VendorCreateContainer formMode="EDIT_VENDOR" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
